import React from "react";
import { Grid } from "@material-ui/core";

import { LoadingSign } from "./index";

export default (props) => {
  return !!props.toLoad ? (
    <React.Fragment>{props.children}</React.Fragment>
  ) : (
    <Grid container justify="center" alignItems="center">
      <LoadingSign />
    </Grid>
  );
};
